class SlidePayCardFormValidator extends EventEmitter {
  constructor() {
    super();
  }

  validate(formEventEmitter) {
    const onTokenSuccess = (hostedFieldsToken) => {
      this.saveToken(hostedFieldsToken, done);
    };

    const onError = (error) => {
      this.emit("error", error);
      done();
    };

    const done = () => {
      this.emit("done");
      $('.card-content-overlay').addClass('card-content-overlay-active');

      formEventEmitter
        .off("token-success", onTokenSuccess)
        .off("error", onError);

      setTimeout(() => location.reload(true), 250);
    };

    formEventEmitter.on("token-success", onTokenSuccess).on("error", onError);

    return this;
  }

  saveToken(hostedFieldsToken, done) {
    var graphQLToken = $("#token").attr("value");
    var graphQLv2Auth = "Bearer " + graphQLToken;
    var graphQLNonce = $("#chirp-monthly-nonce").val();

    sendAjax("chirp_graphql", {
      api_version: "v2",
      authorization: graphQLv2Auth,
      nonce: graphQLNonce,
      graphql_request: `
        mutation saveCreditCard($token: String!, $paymentProviderId: Int!) {
          saveCreditCard(token: $token, paymentProviderId: $paymentProviderId) {
            paymentMethodId
          }
        }
      `,
      graphql_variables: JSON.stringify({
        token: hostedFieldsToken,
        paymentProviderId: 2,
      }),
    })
      .then((response) => {
        if (response.errors) {
          console.log("GraphQL error:", response.errors);
          this.emit("error", "Failed to save card");
        } else {
          this.emit('success', 'Card Saved');
          done();
        }
      })
      .catch((err) => {
        console.log("Error saving card:", err);
        this.emit("error", err.message);
      })
      .finally(() => {
        $('.button-spinner').prop('disabled', false);
      });

    return this;
  }
}

class SlidePayCardFormEventEmitter extends EventEmitter {
  constructor() {
    super();
  }

  initialize(hostedFieldsToken) {
    const setupForm = () => {
      const onFormSubmit = () => {
        $('.button-spinner').prop('disabled', true);
        this.emit("submit");
      }

      const onFormSubmitResponse = (event) => {
        if (event.detail.result) {
          this.emit('token-success', hostedFieldsToken);
        }
      };

      const onFormError = (event) => {
        console.log("hosted form error:", event);
        this.emit("error", event.detail.message);
      };

      const config = this.config(hostedFieldsToken);
      const form = HostedFields.create(config);
      form.addEventListener("submit.processing", onFormSubmit);
      form.addEventListener("submit.result", onFormSubmitResponse);
      form.addEventListener("hostedFields.error", onFormError);

      this.resetForm = () => {
        form.removeEventListener("submit.processing", onFormSubmit);
        form.removeEventListener("submit.result", onFormSubmitResponse);
        form.removeEventListener("hostedFields.error", onFormError);

        return this;
      };
    };

    setupForm();
    return this;
  }

  config(hostedFieldsToken) {
    return {
      amount: 0,
      token: hostedFieldsToken,
      fields: {
        cardNumber: {
          target: "#sp-card-number",
          useTargetStyle: true,
        },
        cardExpiration: {
          target: "#sp-card-exp",
          useTargetStyle: true,
        },
        cardCvv: {
          target: "#sp-card-cvv",
          useTargetStyle: true,
        },
        cardHolderName: {
          target: "#sp-cardholder-name",
          useTargetStyle: true,
        },
        submit: {
          target: "#submit-slidepay",
          useTargetStyle: true,
        },
      },
      styles: {
        "input[type=text]": {
          "font-size": "16px",
          "line-height": "42px",
          "background-position": "9px center",
          "background-repeat": "no-repeat",
          "background-size": "18px 18px",
          display: "block",
          height: "44px",
          padding: "0 1em",
          "background-color": "#FFFFFF",
          border: "1px solid #000000",
          "border-radius": "3px",
          "line-height": "44px",
        },
        "button[type=submit]": {
          display: "inline-block",
          width: "auto",
          height: "44px",
          padding: "0 1.5rem",
          border: "1px solid #239729",
          "border-radius": "3px",
          "line-height": "42px",
          color: "#FFFFFF",
          cursor: "pointer",
          transition: "all 0.25s ease-in-out",
          "background-color": "#000000",
          "border-color": "#000000",
          "font-family": "sans-serif",
          "font-weight": "700",
          "font-size": "16px",
          "text-transform": "capitalize",
        },
        "button[type=submit]:hover:enabled": {
          "background-color": "#00C94B",
          "border-color": "#009738",
        },
        "button[type=submit]:hover:disabled": {
          "cursor": "not-allowed"
        },
        ".saveCard": {
          display: "none",
        },
      },
    };
  }
}

const setupSlidePayCardForm = (refreshAccounts, hostedFieldsToken) => {
  return new PaymentAccountForm({
    accountFormEventEmitter: new SlidePayCardFormEventEmitter(),
    accountFormValidator: new SlidePayCardFormValidator(),
    spinner: $("#add-slidepay-payment .free-spinner"),
    formMessage: $("#add-slidepay-payment .form-card-message"),
    refreshAccounts: refreshAccounts,
  }).initialize(hostedFieldsToken);
};

const removeExistingIframes = () => {
  $('#iframe-cardNumber').remove();
  $('#iframe-cardExpiration').remove();
  $('#iframe-cardCvv').remove();
  $('#iframe-cardHolderName').remove();
  $('#iframe-submit').remove();
}

$(document).ready(async () => {
  var graphQLToken = $("#token").attr("value");
  var graphQLv2Auth = "Bearer " + graphQLToken;
  var graphQLNonce = $("#chirp-monthly-nonce").val();
  let slidePayFormInitialized = false;

  async function initializeCardForm(subscriptionId) {
    $(".card-content-overlay").addClass("card-content-overlay-active");

    try {
      const result = await $.ajax({
        type: "post",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "chirp_graphql",
          api_version: "v2",
          authorization: graphQLv2Auth,
          nonce: graphQLNonce,
          graphql_request: `
          query getSlidePayHostedFieldsToken($subscriptionId: String!, $origin: String!) {
            getSlidePayHostedFieldsToken(subscriptionId: $subscriptionId, origin: $origin) {
              hostedFieldsToken
            }
          }
        `,
          graphql_variables: JSON.stringify({
            subscriptionId,
            origin: window.location.origin,
          }),
        },
      });

      const { data, errors } = JSON.parse(result);

      if (errors) {
        console.log("GraphQL error:", errors);

        const facilityConfigurationError = errors.find(e => e.message.includes('not properly configured for SlidePay'));

        // Short-circuit initializing the form for GPI subscriptions
        if (facilityConfigurationError) {
          console.log('Facility does not have a SlidePay terminal ID assigned');
          return null;
        }

        $(".card-content-message")
          .empty()
          .text("Error retrieving temporary token");

        return;
      }

      return data.getSlidePayHostedFieldsToken.hostedFieldsToken;
    } catch (err) {
      console.log("error retrieving temporary token:", err);

      $(".card-content-message")
        .empty()
        .text("Error retrieving temporary token");
    } finally {
      $(".card-content-overlay").removeClass("card-content-overlay-active");
    }
  }

  async function setupSlidePayForms(subscriptionId) {
    const hostedFieldsToken = await initializeCardForm(subscriptionId);

    const accountForms = await setupAccountPaymentForms(
      slidePayProviderName,
      makeCardLoader("radio"),
      makeBankAccountLoader("radio"),
      hostedFieldsToken
    );

    accountForms.card?.on("success", () => {
      $("#new-credit-card-fields").hide();
      $(".form-card-message", this).empty();
    });

    accountForms.card?.on("success", () => $(".manage-credit-cards"));

    slidePayFormInitialized = true;
  }

  const isOneTimePaymentPage = isAccountPage("monthly-one-time-payment");
  const isRecurringPaymentPage = isAccountPage("monthly-recurring-payments");
  const slidePayProviderName = "SlidePay";

  if (isOneTimePaymentPage || isRecurringPaymentPage) {
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptionId = urlParams.get("subscription");

    if (subscriptionId) {
      await setupSlidePayForms(subscriptionId);
    }

    $("#subscription").change(async function () {
        if (slidePayFormInitialized) {
          removeExistingIframes();
        }

        await setupSlidePayForms(this.value);
    });
  }
});
